
    import '/builds/1N4HJJhF/0/wepie-ee/fe/fe-base/power-design/site/docs/mobile/user-selection.md?watch=parent';
    export const demoIndex = {
  ids: ["docs-mobile-user-selection-demo-user-selection-mobile"],
  getter: () => import(/* webpackChunkName: "meta__docs" */'/builds/1N4HJJhF/0/wepie-ee/fe/fe-base/power-design/site/docs/mobile/user-selection.md?type=demo')
};